import { render, staticRenderFns } from "./PlantingAreaList.vue?vue&type=template&id=b163eb28&scoped=true"
import script from "./PlantingAreaList.vue?vue&type=script&lang=js"
export * from "./PlantingAreaList.vue?vue&type=script&lang=js"
import style0 from "./PlantingAreaList.vue?vue&type=style&index=0&id=b163eb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163eb28",
  null
  
)

export default component.exports